export const canProductInquiry = (product: GQL.IProduct) => {
  return product.status && product.status === 4;
};


// WEBPACK FOOTER //
// ./src/helpers/products/canProductInquiry.ts